<template>
  <transition name="dialog-unroll">
    <div v-if="displaySync" class="dialog-overlay" id="settingsDialog">
      <div
        class="dialog-container !p-0"
        :style="{
          maxHeight: containerHeight,
          width: containerWidth,
          maxHeight: containerMaxHeight,
          maxWidth: containerMaxWidth,
          minHeight: containerMinHeight,
          minWidth: containerMinWidth,
        }"
        :prompt="warningmsg"
      >
        <div class="dialog-header border-b !py-2 !px-4" :style="headerStyle" v-if="isShowHeader">
          <div class="dialog-label" :style="labelStyle">{{ title }}</div>
          <button
            class="close-button !text-[#4f4f4f] font-normal w-[20px] h-[20px]"
            v-if="showClose"
            @click.prevent="closeDialog"
            :style="labelStyle"
          >
            <img src="@/assets/img/close-model.svg" alt="No Data" />
          </button>
        </div>
        <div class="dialog-content !bg-white !mx-[1em] !rounded-xl">
          <div class="scrollable-content">
            <button
              class="close-button"
              style="float: right"
              v-if="showClose && !isShowHeader"
              @click.prevent="closeDialog"
              :style="labelStyle"
            >
              <i class="fa fa-times"></i>
            </button>
            <slot></slot>
          </div>
        </div>
        <div class="dialog-footer" v-if="isShowFooter">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  export default {
    data() {
      return {
        companyInfo: {},
        displaySync: false,
        warningmsg: 'Are you sure to cancel the transaction?',
      };
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: 'Dialog',
      },
      containerHeight: {
        type: String,
        default: 'auto',
      },
      containerWidth: {
        type: String, // You can use Number or String based on your requirement
        default: 'auto', // Default width can be set as per your requirement
      },
      containerMinHeight: {
        type: String,
        default: 'auto',
      },
      containerMinWidth: {
        type: String,
        default: 'auto',
      },
      containerMaxHeight: {
        type: String,
        default: 'auto',
      },
      containerMaxWidth: {
        type: String,
        default: 'auto',
      },
      isBtnShow: {
        type: Boolean,
        default: true,
      },
      disableTopBar: {
        type: Boolean,
        default: false,
      },
      btnDisabled: {
        type: Boolean,
        default: false,
      },
      showClose: {
        // Show and hide the close of dialog Based on requirement
        type: Boolean,
        default: true,
      },
      beforeConfirm: Function,
      confirmText: {
        type: String,
        default: 'Confirm',
      },
      cancelText: {
        type: String,
        default: 'Cancel',
      },
      isShowFooter: {
        // Show and hide the footer of dialog Based on requirement
        type: Boolean,
        default: true,
      },
      isShowHeader: {
        type: Boolean,
        default: true,
      },
      cancelConfirmation: {
        type: Boolean,
        default: false,
      },
      emitClose: {
        type: Boolean,
        default: false,
      },
      prompt: {
        type: String,
      },
    },
    mixins: [PermissionsHelper],
    beforeMount() {
      this.displaySync = this.visible;
      this.getCompanyInfo();
    },
    computed: {
      ...mapGetters('auth', ['getActiveWorkspace']),
      ...mapGetters('company', ['getContactLoginSlug', 'getUpdateCompany', 'getCompanyDetails']),
      ...mapGetters('company', ['getContactLoginSlug']),
      headerStyle() {
        if (this.disableTopBar == true) {
          return {
            backgroundColor: '#ffffff',
            color: 'slategray',
          };
        }
        return {
          backgroundColor: this.companyInfo.dialog_header_color || '#eee', // Default to #eee if menubackground is undefined
        };
      },
      labelStyle() {
        if (this.disableTopBar == true) {
          return {
            color: 'slategray',
          };
        }
        return {
          color: this.companyInfo.dialog_header_text_color || '#808080',
        };
      },
    },
    methods: {
      closeDialog() {
        if (this.cancelConfirmation) {
          this.$confirm(this.prompt, 'Warning', {
            confirmButtonText: this.confirmText,
            cancelButtonText: this.cancelText,
          })
            .then(async () => {
              this.$emit('before-close');
              this.displaySync = false;
            })
            .catch(async (err) => {
              console.log(err);
              this.$emit('before-close-cancel');
            });
        } else {
          this.$emit('before-close');
          if (!this.emitClose) {
            this.displaySync = false;
          }
        }
      },
      async getCompanyInfo() {
        try {
          if (this.getCompanyDetails) {
            this.companyInfo = this.getCompanyDetails;
          } else {
            this.companyInfo = { ...this.getContactLoginSlug };
          }
        } catch (e) {
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: e,
          });
        }
      },
    },
    watch: {
      visible(newValue) {
        if (this.displaySync != newValue) {
          this.displaySync = newValue;
        }
      },
    },
  };
</script>

<style scoped>
  .el-color-picker--mini {
    height: auto !important;
  }

  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(5px) !important;
  }

  .dialog-container {
    background: linear-gradient(180deg, var(--brand-200) 0%, #fff 51.15%) !important;
    padding: 0.75rem;
    border-radius: 12px;
    overflow: hidden;
    margin: 0 2vw;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }

  .el-dialog__wrapper {
    min-height: 400px !important;
  }

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent !important;
    padding: 4px 0 8px;
    border: 0;
  }

  .dialog-header .dialog-label {
    color: #4f4f4f !important;
    font-size: clamp(1rem, 1.25vw, 1.5rem);
    font-weight: 400;
  }

  .dialog-label {
    margin: 0;
  }

  .close-button {
    cursor: pointer;
    background: none;
    border: none;
    font-size: 20px;
    color: #555;
  }

  .dialog-content {
    overflow-y: auto !important;
    scrollbar-width: thin;
    padding: 4px 8px 14px 14px !important;
  }
  .dialog-footer {
    padding: 10px 20px;
    border-radius: 0 0 12px 12px;
    background-color: var(--black-100) !important;
    position: sticky;
    bottom: 0;
    z-index: 0;
    display: flex;
    justify-content: flex-end;
  }

  @media screen and (max-width: 1006px) {
    /* Add your custom styles here */
    .dialog-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5) !important;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 100000;
      backdrop-filter: blur(5px) !important;
    }

    .dialog-container {
      background: linear-gradient(180deg, var(--brand-200) 0%, #fff 51.15%) !important;
      padding: 0.75rem;
      border-radius: 12px;
      overflow: hidden;
      margin: 0px;
      max-width: calc(100%);
      max-height: 760px;
      display: flex;
      flex-direction: column;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      position: sticky;
      top: 0;
      z-index: 0;
    }

    .dialog-label {
      margin: 0;
    }

    .close-button {
      cursor: pointer;
      background: none;
      border: none;
      font-size: 20px;
      color: #555;
    }

    .dialog-content {
      flex-grow: 1;
    }

    .scrollable-content {
      overflow-y: auto;
      padding: 0px 5px 0px 5px;
      overflow-x: hidden;
    }

    .dialog-footer {
      padding: 8px 8px;
      background: #eee;
      position: sticky;
      bottom: 0;
      z-index: 0;
      display: flex;
      justify-content: flex-end;
    }
  }

  @media screen and (max-width: 1366px) and (max-height: 768px) {
    .dialog-footer {
      padding: 5px 20px !important;
    }
  }
</style>
